const aws = require('aws-sdk')
import axios from "axios"

const instance = axios.create();
delete instance.defaults.headers.common['Authorization'];

aws.config.update({
    secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
    accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY
})

const s3 = new aws.S3({
    signatureVersion: 'v4',
    region: process.env.VUE_APP_AWS_REGION || 'us-west-1',
    accesskeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
})

export default {
    async singleUpload(file, folder, progressCallback = null) {
        const key = folder + '/' + Date.now() + '-' + file.name.replace(/\s/g, '-')
        const params = {
            Bucket: process.env.VUE_APP_AWS_BUCKET || 'dimitra-admin-panel-fe-s3-dev',
            Key: key,
            Expires: 10,
            ContentType: file.type,
        }

        const url = s3.getSignedUrl('putObject', params);
        
        return await instance
            .put(url, file, {
                headers: {
                    'Content-Type': file.type,
                },
                 // Track the upload progress here
                onUploadProgress: progressEvent => {
                    const loaded = progressEvent.loaded;
                    const total = progressEvent.total;
                    const percentCompleted = Math.round((loaded * 100) / total);

                    if (progressCallback) {
                        progressCallback(percentCompleted);
                    }
                },
            })
            .then(result => {
                const bucketUrl = decodeURIComponent(result.request.responseURL).split(
                    key
                )[0]
                result.key = key
                result.fullPath = bucketUrl + key
                return result
            })
            .catch(err => {
                console.log(err);
                console.error('Error generating signed URL from S3:', err);
                throw new Error('Could not generate signed URL.');
            })
    },
    
    // generate url for viewing the file
    async getFileUrl(fileKey) {
        const params = {
            Bucket: process.env.VUE_APP_AWS_BUCKET || 'dimitra-admin-panel-fe-s3-dev',
            Key: fileKey,
            Expires: 300, // Expiry time for the URL
        };

        try {
            const url = s3.getSignedUrl('getObject', params);
            return url;
        } catch (error) {
            console.error('Error generating signed URL for viewing:', error);
            throw new Error('Could not generate viewable URL.');
        }
    },

    async bolbImageUpload(file, folder) {
        let fileExtension;
        switch (file.type) {
            case 'image/png':
                fileExtension = 'png';
                break;
            case 'image/jpeg':
                fileExtension = 'jpg';
                break;
            case 'image/gif':
                fileExtension = 'gif';
                break;
            default:
                throw new Error('Unsupported file type');
        }
        const key = `${folder}/${Date.now()}-${Math.floor(Math.random() * 10000)}.${fileExtension}`;
        const params = {
            Bucket: process.env.VUE_APP_AWS_BUCKET,
            Key: key,
            Expires: 10,
            ContentType: file.type,
        }
        const url = s3.getSignedUrl('putObject', params)
        return await instance
            .put(url, file, {
                headers: {
                    'Content-Type': file.type,
                },
            })
            .then(result => {
                const bucketUrl = decodeURIComponent(result.request.responseURL).split(
                    key
                )[0]
                result.key = key
                result.fullPath = bucketUrl + key
                return result
            })
            .catch(err => {
                console.error('Error generating signed URL from S3:', err);
            })
    },
    async imageUpload(file, folder, progressCallback = null) {
        const key = folder + '/' + Date.now() + '-' + file.name.replace(/\s/g, '-');
        const params = {
            Bucket: process.env.VUE_APP_AWS_BUCKET || 'dimitra-admin-panel-fe-s3-dev',
            Key: key,
            ContentType: file.type,
        };
    
        // Direct upload to S3 using the AWS SDK
        try {
            await s3.upload({
                ...params,
                Body: file,
            }).on('httpUploadProgress', progressEvent => {
                const loaded = progressEvent.loaded;
                const total = progressEvent.total;
                const percentCompleted = Math.round((loaded * 100) / total);
    
                if (progressCallback) {
                    progressCallback(percentCompleted);
                }
            }).promise();
    
            // Construct the public URL of the uploaded file
            const bucketUrl = `https://${params.Bucket}.s3.amazonaws.com/`;
            const fullPath = bucketUrl + key;
    
            return {
                key,
                fullPath,
            };
        } catch (err) {
            console.error('Error uploading file to S3:', err);
            throw new Error('Could not upload file to S3.');
        }
    }
    
}